module.exports = __webpack_public_path__ + "img/39_004_013_c.929c017f.png";